import { HttpClient } from '@angular/common/http';
import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Router } from '@angular/router';
import { PNotifyService } from '../../../services/pnotify.service';

@Component({
  selector: 'app-push-datatable',
  templateUrl: './push-datatable.component.html',
  styleUrls: ['./push-datatable.component.css']
})
export class PushDatatableComponent implements OnInit, OnDestroy {

  filter = { status: '' };
  staticFilter = { status: '' };

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  dtOptions: any = {};
  notifications: any[];
  pnotify = undefined;

  constructor(
    private http: HttpClient,
    private router: Router,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {
    console.log('[PushDatatable] Constructor started');
    this.pnotify = pnotifyService.getPNotify();
  }

  ngOnInit(): void {
    const self = this;
    this.dtOptions = {
      searching: false,
      pageLength: 10,
      serverSide: true,
      processing: true,
      lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
      order: [[4, 'desc']],
      ordering: false,
      ajax: (dataTablesParameters: any, callback) => {
        const params = { ...dataTablesParameters, ...this.staticFilter };
        this.http.get('/api/push', { params }).subscribe((resp: any) => {
          this.notifications = resp.data;
          const dta = [];
          this.notifications.forEach(n => {
            const statusLabels = {
              draft: 'Brouillon',
              pending: 'En attente',
              sent: 'Envoyé',
              cancelled: 'Annulé',
              failed: 'Échec'
            };
            const statusClass = {
              draft: 'label-default',
              pending: 'label-warning',
              sent: 'label-success',
              cancelled: 'label-default',
              failed: 'label-danger'
            };
            dta.push({
              id: n.id,
              title: n.title,
              targetAudience: n.cityName ? n.cityName : (n.targetAudience === 'all' ? 'Tous' : n.targetAudience === 'parents' ? 'Parents' : 'Clients'),
              targetApp: n.targetApp === 'both' ? 'Les deux' : n.targetApp === 'madarstop' ? 'Madarstop' : 'Madar Pro',
              createdAt: n.createdAt ? new Date(n.createdAt).toLocaleString('fr-FR') : '',
              status: `<span class="label ${statusClass[n.status] || 'label-default'}">${statusLabels[n.status] || n.status}</span>`,
              sentCount: n.sentCount || 0,
              failedCount: n.failedCount || 0,
              actions: `
              <a class="btn btnAction btnNavigate" data-url="/push/view/${n.id}">
                <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
              </a>
              ${n.status !== 'sent' ? `
              <a class="btn btnAction btnNavigate" data-url="/push/edit/${n.id}">
                <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>Modifier
              </a>
              <button class="btn btnAction btnDelete" data-id="${n.id}">
                <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
              </button>
              ` : ''}
            `
            });
          });
          callback({
            recordsTotal: resp.total,
            recordsFiltered: resp.total,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'push_' + aData.id);
      },
      columns: [
        { data: 'title', title: 'Titre' },
        { data: 'targetAudience', title: 'Audience' },
        { data: 'targetApp', title: 'Application' },
        { data: 'createdAt', title: 'Créé le' },
        { data: 'status', title: 'Statut' },
        { data: 'sentCount', title: 'Envoyés' },
        { data: 'failedCount', title: 'Échecs' },
        { data: 'actions', title: 'Actions' }
      ],
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      responsive: true
    };
    $('table').on('click', '.btnDelete', (event) => {
      this.onDelete($(event.currentTarget).data('id'));
    });
    $('table').on('click', '.btnNavigate', (event) => {
      this.onNavigate($(event.currentTarget).data('url'));
    });
  }

  ngOnDestroy(): void {
    $('table').off();
  }

  onNavigate(url) {
    this.zone.run(() => this.router.navigateByUrl(url));
  }

  onDelete(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cette notification ?',
      stack: { firstpos1: 70, firstpos2: 10, modal: true, overlay_close: true },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok', addClass: 'btn btn-chico',
              click: notice => {
                this.delete(id);
                notice.close();
              }
            },
            {
              text: 'Annuler', addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  delete(id) {
    this.http.delete('/api/push/' + id).subscribe(
      result => {
        document.getElementById('push_' + id).remove();
      },
      error => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: { firstpos1: 70, firstpos2: 10, modal: true, overlay_close: true },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [{ text: 'Ok', addClass: 'btn btn-chico', click: notice => { notice.close(); } }]
            }
          }
        });
      }
    );
  }

  onFilter(): void {
    this.staticFilter = { ...this.filter };
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/push/push-datatable/push-datatable.component.ts